module.exports = __webpack_public_path__ + "/images/logo-af-target.2c782d7.svg";